import { render } from "./billDoc.vue?vue&type=template&id=42825286&scoped=true"
import script from "./billDoc.vue?vue&type=script&lang=js"
export * from "./billDoc.vue?vue&type=script&lang=js"

import "./billDoc.vue?vue&type=style&index=0&id=42825286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42825286"]])

export default __exports__